<template>
<svg width="19" height="19" viewBox="0 0 19 19" stroke="" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
        <circle cx="7" cy="7" r="6" stroke-width="2"/>
        <line x1="17.5858" y1="18" x2="11" y2="11.4142" stroke-width="2" stroke-linecap="round"/>
    </g>
</svg>
</template>

<script>
export default {
  name: 'IconSearch',
};
</script>
